import { designSystemTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';
import { ReactComponent as LogoFr } from './images/WealthFr.svg';
import { ReactComponent as LogoEn } from './images/WealthEn.svg';

const appTheme: AppTheme = {
  ...designSystemTheme,
  assets: {
    ...designSystemTheme.assets,
    logoFr: LogoFr,
    logoEn: LogoEn,
    horizontalLogoFr: LogoFr,
    horizontalLogoEn: LogoEn,
    horizontalLogoInvFr: LogoFr,
    horizontalLogoInvEn: LogoEn,
  },

  MainLogo: {
    ...designSystemTheme.MainLogo,
    width: '105px',
    height: '54px',
    lgWidth: '105px',
    lgHeight: '54px',
  },

  layout: {
    ...designSystemTheme.layout,
    maxContentWidth: 100000,
  },
  Modal: {
    ...designSystemTheme.Modal,
    background: '#fff',
    closeButtonBackground: 'transparent',
    closeButtonHoverBackground: 'transparent',
    closeButtonActiveBackground: 'transparent',
  },
};

export default appTheme;
